import React, { ChangeEvent, useEffect, useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import "./inputStyles.scss";
import { InputType } from "reactstrap/types/lib/Input";

interface ITextFieldProps {
  value: string;
  name?: string;
  label?: string;
  className?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: Function;
  onBlur?: Function;
  onClick?:  Function;
  type?: InputType;
  error?: any;
  readOnly?:boolean;
 
}

const TextInput = (props: ITextFieldProps) => {
  // props
  const {
    value,
    name,
    label,
    className,
    placeholder,
    required,
    disabled,
    onChange,
    onBlur,
    onClick,
    error,
    type,
    readOnly
  } = props;

  // states
  const [inputValue, setInputValue] = useState(value || "");

  // handler functions
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange && onChange(e);
    setInputValue(e?.target?.value || "");
  };

  // useEffects
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <FormGroup className={`input-field ${className ?? ""} selection`} onClick={(e: any) => onClick && onClick(e)}>
      { label ? <Label>
        {label}
        {required ? <span className="input-required">*</span> : <></>}
      </Label> : <></>}
      <Input
        name={name}
        value={inputValue}
        onChange={handleChange}
        onBlur={(e: any) => onBlur && onBlur(e)}
        required={required}
        disabled={disabled}
        placeholder={placeholder}
        type={type ?? 'text'}
        readOnly = {readOnly}
      />
      { error ? <div className="error-field">{error}</div> : <></> }
    </FormGroup>
  );
};

export default TextInput;
